import api from '__jsVueApi';
export default {
	async getProfile({ state, commit }, payload) {
		commit('main/setLoad', true, { root: true });
		const url = payload?.id ? `${api.admin.users.get(payload.id)}` : api.profile.get;
		await axios
			.get(url, {
				params: {
					expand:         ['major_market.region', 'sub_market.region'],
					followed_limit: 4
				}
			})
			.then((response) => {
				let profile = response.data;
				if (!profile.sub_market) {
					profile.sub_market = {
						id:   null,
						name: ''
					};
				}
				else {
					profile.sub_market.name = `${profile.sub_market.name}, ${profile.sub_market.region.name}`;
				}
				if (!profile.major_market) {
					profile.major_market = {
						id:   null,
						name: ''
					};
				}
				else {
					profile.major_market.name = `${profile.major_market.name}, ${profile.major_market.region.name}`;
				}
				commit('setProfile', profile);
			})
			.catch((err) => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
	async setProfile({ state, commit, dispatch, rootState }, { id, photo }) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		commit('main/setLoad', true, { root: true });
		const url = id ? api.admin.users.edit(id) : api.profile.set;
		await axios
			.patch(url, {
				about:                state.profile.about,
				email:                state.profile.email,
				id:                   state.profile.id,
				major_market:         state.profile.major_market.id,
				name:                 state.profile.name,
				phone:                state.profile.phone,
				photo:                (photo) || (undefined),
				profile_type:         state.profile.profile_type,
				profile_url:          state.profile.profile_url,
				sub_market:           state.profile.sub_market.id,
				show_contact_details: state.profile.show_contact_details,
				type:                 state.profile.radiotype,
			})
			.then(async(response) => {
				await dispatch('getProfile', { id });
			})
			.catch((err) => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
	async changePassword({ state, commit, dispatch, rootState }) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		commit('main/setLoad', true, { root: true });
		await axios
			.post(api.profile.changePassword, {
				old_password:  state.currentPassword,
				new_password1: state.newPassword,
				new_password2: state.repeatPassword,

			})
			.then((response) => {
				window.location.href = '/login?next=/profile/';
			})
			.catch((error) => {
				commit('setChangePasswordErrors', error.response.data);
			});
		commit('main/setLoad', false, { root: true });
	},

	async delete({ state, commit, dispatch, rootState }) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		await axios
			.delete(api.profile.delete)
			.then(() => {
				commit('setProfile', false);
				window.location.href = '/login?next=/profile/';
			})
			.catch((err) => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},

	async loadSubscription({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.profile.subscription.get)
			.then((response) => {
				commit('setSubscription', response.data);
			})
			.catch((err) => {
				commit('main/setLoad', false, { root: true });
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},

	async cancelSubscription({ state, commit }, data) {
		commit('main/setLoad', true, { root: true });
		await axios
			.post(api.profile.subscription.cancel, data)
			.then(() => commit('main/setMessage', 'Cancellation request sent', { root: true }))
			.catch((err) => {
				commit('main/setLoad', false, { root: true });
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
};
